import React, {useState} from 'react';
import {Button, Drawer, Form, message, Select, Tag, Upload} from "antd";
import {SettingOutlined, UploadOutlined} from '@ant-design/icons';
import {templateExport, templateImport} from "../../apis/admin";
import moment from "moment";

function ImportExportSection(props) {
    const {pid, sectionIdOption} = props
    const [opened, setOpened] = useState(false);
    const [uploadFile, setUploadFile] = useState({uploading: false, fileList: []});
    const [form] = Form.useForm()
    const {Option} = Select
    const fileDownload = require('js-file-download');

    const config = {
        beforeUpload: file => {
            setUploadFile({...uploadFile, fileList: [file]})
            return false;
        },
        fileList: uploadFile.fileList
    };

    const sectionSetting =
        <Form
            className='import-export-form'
            form={form}
            layout='vertical'
            hideRequiredMark={true}
        >
            <Tag color='default'>請先從選擇需要更改項目開始</Tag>
            <Form.Item
                name='sectionId'
                rules={[{ required: true, message: '請選擇項目' }]}
            >
                <Select
                    placeholder='表格項目'
                >
                    {
                        Object.keys(sectionIdOption.importExport).map((id, i) => {
                            return (
                                <Option
                                    key={i}
                                    value={id}
                                >
                                    {sectionIdOption.importExport[id]}
                                </Option>
                            )
                        })
                    }
                </Select>
            </Form.Item>

            <div className='import-export-section'>
                <Tag color='default'>導出範本以獲得最新檔案格式 (.xlsx)</Tag>
                <Form.Item>
                    <Button htmlType='submit' onClick={() => exportSection()}>導出檔案</Button>
                </Form.Item>
                <Tag color='default'>選取填妥的表格設定檔案以作上傳 (.xlsx)</Tag>
                <div className='uploader'>
                    <Upload
                        {...config}
                        multiple={false}
                        accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        showUploadList={
                            {
                                showPreviewIcon: false,
                                showRemoveIcon: false,
                                showDownloadIcon: false
                            }
                        }
                    >
                        <Button>
                            <UploadOutlined /> 選取檔案
                        </Button>
                    </Upload>
                    <Form.Item>
                        <Button
                            htmlType='submit'
                            onClick={() => importSection()}
                            disabled={uploadFile.fileList.length === 0}
                            loading={uploadFile.uploading}
                        >
                            {uploadFile.uploading ? '上傳中' : '上傳檔案'}
                        </Button>
                    </Form.Item>
                </div>
            </div>


        </Form>



    const importSection = async () => {
        const sectionId = form.getFieldValue('sectionId')

        if(sectionId) {
            setUploadFile({...uploadFile, uploading: true})
            try {
                const res = await templateImport(pid, sectionId, uploadFile.fileList[0]);
                if (res.error) {
                    throw new Error(`${res.error.msgCode} - ${res.error.message}`);
                } else {
                    message.success('上傳成功');
                }
            } catch (e) {
                console.log(e)

                message.error('上傳失敗，請重新再試');
            } finally {
                setUploadFile({...uploadFile, uploading: false})
            }
        }
    }

    const exportSection = async () => {
        const sectionId = form.getFieldValue('sectionId')
        if(sectionId){
            try {
                const res = await templateExport(pid, sectionId);
                if (res.type.includes('application/json')) {
                    let reader = new FileReader()
                    reader.onload = function (event) {
                        let content = reader.result
                        let errMessage = JSON.parse(content).message // 错误信息

                        throw new Error(`${errMessage}`);
                        message.error('下載失敗，請重新再試');
                    }
                    // reader.readAsText(res)

                } else {
                    fileDownload(res, `Report ${moment().format('DDMMYYYY') }.xlsx`);
                }
            } catch(e){
                console.log(e)
            }
        }
    }

    const showDrawer = () => {
        setOpened(true)
    };

    const onClose = () => {
        setOpened(false)
    };

    return (
        <>
            <Button onClick={showDrawer}>
                <SettingOutlined /> 更改表格設定
            </Button>
            <Drawer
                className='section-setting'
                title="上傳表格設定"
                width={380}
                onClose={onClose}
                visible={opened}
                bodyStyle={{ paddingBottom: 80 }}
            >
                {sectionSetting}

            </Drawer>
            </>
    );
}

export default ImportExportSection;
